// extracted by mini-css-extract-plugin
module.exports = {"documentPreviewCanvas":"DocumentPdfSharedStyles_documentPreviewCanvas__2nXup","pageButtons":"DocumentPdfSharedStyles_pageButtons__2EUJB"};